/* Lightbox — view an uploaded file (image or PDF) inline, in a modal,
   instead of redirecting to a new browser tab. file = { data, name, type }. */
export default function Lightbox({ file, onClose }) {
  if (!file) return null;
  const isImg = /^image\//.test(file.type || "") || /^data:image\//.test(file.data || "");
  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, zIndex: 300,
      background: "rgba(15,15,20,.82)", display: "flex", alignItems: "center",
      justifyContent: "center", padding: 20 }}>
      <div onClick={e => e.stopPropagation()} style={{ background: "#fff", borderRadius: 16,
        width: "100%", maxWidth: 920, maxHeight: "94vh", overflow: "hidden",
        display: "flex", flexDirection: "column" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center",
          padding: "12px 16px", borderBottom: "1px solid #ECECEF", gap: 10 }}>
          <span style={{ fontWeight: 800, fontSize: 14, color: "#1E1E26",
            whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
            {file.name || "File"}</span>
          <div style={{ display: "flex", gap: 8, flexShrink: 0 }}>
            <a href={file.data} download={file.name || "file"}
              style={{ background: "#FFC400", color: "#3D2E00", fontWeight: 800, fontSize: 13,
                padding: "8px 14px", borderRadius: 9, textDecoration: "none" }}>Download</a>
            <button onClick={onClose} style={{ background: "#F1F1F4", border: "none",
              color: "#5C5C68", fontWeight: 800, fontSize: 13, padding: "8px 14px",
              borderRadius: 9, cursor: "pointer" }}>Close</button>
          </div>
        </div>
        <div style={{ flex: 1, overflow: "auto", background: "#1d1d22", display: "flex",
          alignItems: "center", justifyContent: "center", minHeight: 280 }}>
          {isImg
            ? <img src={file.data} alt={file.name || ""}
                style={{ maxWidth: "100%", maxHeight: "84vh", display: "block" }} />
            : <iframe title={file.name || "file"} src={file.data}
                style={{ width: "100%", height: "84vh", border: "none", background: "#fff" }} />}
        </div>
      </div>
    </div>
  );
}
